import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ProfileDocumentsComponent from './documents.component';

const profileDocumentsModule = angular.module('tinaba.components.profile.documents', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('profile.documents', {
      url: '/documents',
      template: '<profile-documents></profile-documents>'
    });
})

.component('profileDocuments', ProfileDocumentsComponent);

export default profileDocumentsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/documents/documents.js
 **/